<div class="container">
    <div class="headerBtn">
        <input type="text" placeholder="Search by Name" [(ngModel)]="searchTerm" (input)="onSearch()" class="searchField" />
        <button type="button" pButton label="Export" (click)="onExport()" icon="pi pi-file"
            style="background-color: #5181FF;margin-bottom: 10px;"></button>
    </div>
    <div class="button-toolbar" *ngxPermissionsOnly="['clinician']">
        <button type="button" [disabled]="!selectedProduct" pButton pTooltip="Edit" tooltipPosition="top" icon="pi pi-pencil"
            style="background-color: #5181FF;" (click)="editUser(selectedProduct)"></button>
    </div>
    <div class="button-toolbar" *ngxPermissionsOnly="['admin']">
        <button type="button" [disabled]="!selectedProduct" pButton pTooltip="Edit" tooltipPosition="top" icon="pi pi-pencil"
            style="background-color: #5181FF;" (click)="editUser(selectedProduct)"></button>
        <button type="button" [disabled]="!selectedProduct" pButton pTooltip="Delete" tooltipPosition="top" icon="pi pi-trash"
            (click)="deleteUser(selectedProduct)" style="background-color: #5181FF;"></button>
    </div>
    <div class="button-toolbar" *ngxPermissionsOnly="['superadmin']">
        <button *ngIf="tabIndex!==2"type="button" [disabled]="!selectedProduct" pButton pTooltip="Edit" tooltipPosition="top" icon="pi pi-pencil"
            style="background-color: #5181FF;" (click)="editUser(selectedProduct)"></button>
        <button type="button" [disabled]="!selectedProduct" pButton pTooltip="Delete" tooltipPosition="top" icon="pi pi-trash"
            (click)="deleteUser(selectedProduct)" style="background-color: #5181FF;"></button>
        <button *ngIf="tabIndex===4" type="button" [disabled]="!selectedProduct || isApprovedByApprover(selectedProduct)" pButton label="Approve User" icon="pi pi-check"
            (click)="approveUser(selectedProduct)" style="background-color: #5181FF;"></button>
    </div>


    <p-table [value]="datalist" styleClass="p-datatable-gridlines p-datatable-sm"
        style="min-width: 10rem; width: 200px;" (onSort)="onSort($event)" [scrollable]="true" scrollHeight="400px"
        selectionMode="single" [(selection)]="selectedProduct" (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect()">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;"></th>
                <ng-container *ngFor="let col of fieldsConfig.Columns; let colIdx=index;">
                    <th *ngIf="col.sortable" pSortableColumn="{{ col.Field }}">
                        {{ col.HeaderTxt }} <p-sortIcon [field]="col.Field"></p-sortIcon>
                    </th>
                    <th *ngIf="!col.sortable">
                        {{ col.HeaderTxt }}
                    </th>
                </ng-container>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-product let-col="col" let-rowIndex="rowIndex">
            <tr>
                <td style="width: 50px;">
                    <p-tableRadioButton [value]="product"></p-tableRadioButton>
                </td>
                <ng-container *ngFor="let col of fieldsConfig.Columns">
                    <td *ngIf="col.Template; else defaultTemplate">
                        <ng-container
                            *ngTemplateOutlet="getTemplate(col.Template); context: { $implicit: product }"></ng-container>
                    </td>
                    <ng-template #defaultTemplate>
                        <td style="word-break: break-all;">{{ product | nestedData: col.Field }}</td>
                    </ng-template>
                </ng-container>
            </tr>
        </ng-template>
    </p-table>
    <ng-template #nameTemplate let-product>
        <span style="padding: 8px 0px;">{{ product?.FirstName }} &nbsp;{{ product?.LastName }}</span>
    </ng-template>
    <ng-template #ageTemplate let-product>
        <td class="removeBorders">
            {{ getAgeFromBirthDate(product | nestedData : 'DOB') }}
        </td>
    </ng-template>
    <ng-template #createdDateTemplate let-product>
        <td class="removeBorders">
            {{ product.CreateDate | date: 'MM/dd/yyyy' }}
        </td>
    </ng-template>
    <ng-template #modifiedDateTemplate let-product>
        <td class="removeBorders">
            {{ product.ModifiedDate | date: 'MM/dd/yyyy' }}
        </td>
    </ng-template>
</div>
